import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import selectors from '../../../../../store/shared/selectors'
import * as adminActivitiesDuck from '../../adminActivitiesDuck'
import * as adminSubordinatesDuck from '../../adminSubordinatesDuck'
import ChildTabView from '../ChildTabView/ChildTabView'
import StudentActivities from '../StudentActivities/StudentActivities'
import sampleStudentData from './sampleStudent.json'

/**
 * @class StudentDetailsView
 * @description Display for an individual student
 */
class StudentDetailsView extends Component {
  /**
   * @static propTypes
   */
  static propTypes = {
    activeIndex: PropTypes.number.isRequired,
    performRetrieveStudentActivities: PropTypes.func.isRequired,
    selectActiveStudent: PropTypes.func.isRequired,
    students: PropTypes.array.isRequired,
    studentActivities: PropTypes.object.isRequired,
    isLessThanMedium: PropTypes.bool,
  }

  /**
   * @method componentWillMount
   * @description Retrieves student activities
   */
  componentWillMount() {
    this.props.performRetrieveStudentActivities()
  }

  /**
   * @method render
   */
  render() {
    const studentData = this.props.students.length
      ? this.props : sampleStudentData

    const { activeIndex, selectActiveStudent, students, studentActivities, isLessThanMedium } = studentData

    if (!students.length) {
      return (
        <div className="row text-center">
          <h1>No Students Found</h1>
        </div>
      )
    }

    const activeStudent = students[activeIndex]

    return (
      <div className="row m-0">
        <div className="col-12 col-md-4 col-lg-3 p-0">
          <ChildTabView
            students={students}
            activeStudentId={activeStudent._id}
            onClick={selectActiveStudent}
            isMobile={isLessThanMedium}
          />
        </div>
        <div className="col-md-8 col-lg-9 admin-detail-container">
          <StudentActivities student={activeStudent} activities={studentActivities} isMobile={isLessThanMedium} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  activeIndex: adminSubordinatesDuck.getActiveIndex(state),
  studentActivities: adminActivitiesDuck.getStudentActivitiesWithTaskType(state),
  students: adminSubordinatesDuck.getSubordinateStudents(state),
  isLessThanMedium: selectors.isLessThanMedium(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectActiveStudent: adminSubordinatesDuck.setActiveIndex,
      performRetrieveStudentActivities: adminActivitiesDuck.performRetrieveActivities,
    },
    dispatch,
  )

export default connect(mapStateToProps, mapDispatchToProps)(StudentDetailsView)



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/components/StudentDetailsView/StudentDetailsView.js